import { Errors } from 'system/libs/Errors';

define(['jQuery', 'inherit', '../blocks/add-dialog/add-dialog', 'Emitter'], (
    $,
    inherit,
    AddDialogView,
    Emitter,
) => {
    function AddDialog(settings) {
        if (settings.titleText !== undefined) {
            this.titleText = settings.titleText;
        }

        if (settings.approveText !== undefined) {
            this.approveText = settings.approveText;
        }

        if (settings.labelText !== undefined) {
            this.labelText = settings.labelText;
        }

        if (settings.placeholder !== undefined) {
            this.placeholder = settings.placeholder;
        }

        if (settings.desc !== undefined) {
            this.desc = settings.desc;
        }

        if (settings.message !== undefined) {
            this.message = settings.message;
        }

        if (settings.validator !== undefined) {
            this._validator = settings.validator;
        }

        this._errors = $.extend(
            {},
            this._errors === AddDialog.fn._errors
                ? this._errors
                : $.extend({}, AddDialog.fn._errors, this._errors),
            settings.errors || {},
        );
    }

    AddDialog.fn = AddDialog.prototype = {
        titleText: 'Добавить',
        approveText: 'Создать',
        labelText: 'Введите параметры поиска',

        _errors: {
            default: 'Произошла ошибка',
            argument_invalid: 'Вы ввели некорректные данные',
            argument_required: 'Заполните поле',
            not_found: 'Не найдено',
            conflict: 'Уже добавлено',
        },

        show() {
            this._view = new AddDialogView({
                el: $('<div/>').appendTo('.layers'),

                data: {
                    title: this.titleText,
                    approveText: this.approveText,
                    labelText: this.labelText,
                    errors: this._errors,
                    placeholder: this.placeholder,
                    desc: this.desc,
                    message: this.message,
                },
            });

            this._view.show();

            this._view.on('close', () => {
                'use strict';
            });

            this._view.on('close', () => {
                // this.close();
                this.emit('cancel');
            });

            this._view.on('approve', (e, data) => {
                if (!this._validator || this._validator(data)) {
                    this.toggleLoading(true);
                    this.emit('approve', data);
                } else {
                    this.setErrors([
                        {
                            error: 'invalid',
                        },
                    ]);
                }
            });
        },

        hide() {
            'use strict';

            if (this._view) {
                this._view.hide();
            }

            this._view = null;
        },

        close() {
            if (this._view) {
                this._view.close();
            }

            this._view = null;
        },

        deleteItems(items) {
            if (this._view) {
                this._view.deleteItems(items);
            }
        },

        toggleLoading(/* state */) {
            // this._view.setWaiting(state);
        },

        setErrors(errors) {
            const messages = (errors = Errors.getErrorMessage(
                errors,
                this._errors,
            ));

            this._view.setErrors(messages);

            this.toggleLoading(false);
        },

        destroy() {
            if (this._view) {
                this._view.destroy();
            }
            // this.close();
        },
    };

    Emitter.apply(AddDialog.fn);

    AddDialog.extend = function(methods) {
        return inherit(this, methods);
    };

    return AddDialog;
});
